export default __webpack_public_path__ + "static/media/avatar_92.faace271.png";